import Text from './Text';


Text.install = function(Vue) {
  Vue.component(Text.name, Text);
};

export default Text;
